interface Props {
  totalSent: number;
  successRate: number;
  credit: number;
  apiRequests: number;
  loading: boolean;
}

export default function StatsOverview({ totalSent, successRate, credit, apiRequests, loading }: Props) {
  const cards = [
    {
      icon: "ri-send-plane-line",
      color: "text-violet-400",
      bg: "bg-violet-500/10",
      label: "총 발송 건수",
      value: totalSent.toLocaleString(),
      unit: "건",
    },
    {
      icon: "ri-shield-check-line",
      color: "text-emerald-400",
      bg: "bg-emerald-500/10",
      label: "발송 성공률",
      value: `${successRate}%`,
      unit: "",
    },
    {
      icon: "ri-wallet-3-line",
      color: "text-pink-400",
      bg: "bg-pink-500/10",
      label: "보유 크레딧",
      value: credit.toLocaleString(),
      unit: "원",
    },
    {
      icon: "ri-key-2-line",
      color: "text-amber-400",
      bg: "bg-amber-500/10",
      label: "API 총 요청",
      value: apiRequests.toLocaleString(),
      unit: "건",
    },
  ];

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
      {cards.map((c) => (
        <div
          key={c.label}
          className="bg-white/[0.03] border border-white/[0.08] rounded-2xl p-5 hover:border-white/[0.12] transition-colors"
        >
          <div className="flex items-center gap-2.5 mb-3">
            <div className={`w-8 h-8 flex items-center justify-center rounded-lg ${c.bg}`}>
              <i className={`${c.icon} ${c.color} text-base`} />
            </div>
            <span className="text-gray-500 text-xs">{c.label}</span>
          </div>
          <div className="flex items-baseline gap-1">
            {loading ? (
              <div className="h-7 w-16 bg-white/[0.05] rounded animate-pulse" />
            ) : (
              <span className="text-white text-2xl font-bold">{c.value}</span>
            )}
            {!loading && c.unit && <span className="text-gray-500 text-xs">{c.unit}</span>}
          </div>
        </div>
      ))}
    </div>
  );
}